<template>
  <div class="px-5 py-4">
    <div class="w-[993px] max-w-full">
      <integration-page-header
        title-row-class="mt-6"
        :title="$t('INTEGRATION_SETTINGS.MOBILE_APP.PAGE_TITLE')"
      >
        <template #actions>
          <div class="flex flex-row items-center gap-4">
            <a
              href="https://play.google.com/store/apps/details?id=co.il.digital99.chat"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://d33wubrfki0l68.cloudfront.net/fb32fa6315ef7b4721fce6f662fdf10f62a3a2a5/05af7/images/home/mobile-apps/play-store.png"
                alt="Google play store"
                class="h-10 w-[120px] object-fill"
              />
            </a>
            <a
              href="https://apps.apple.com/app/id1598783695"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://d33wubrfki0l68.cloudfront.net/814d5384ef54c6996e1ebb76c103acd448eaf018/a45fc/images/home/mobile-apps/app-store.png"
                alt="Apple app store"
                class="h-10 w-[120px] object-fill"
              />
            </a>
          </div>
        </template>
      </integration-page-header>
      <div class="text-base leading-6 text-gray-600 mt-1 max-w-[650px]">
        {{ $t('INTEGRATION_SETTINGS.MOBILE_APP.PAGE_DESC') }}
      </div>

      <div
        class="mt-6 bg-white rounded-[12px] border border-gray-100 py-8 px-11 grid grid-cols-[440px_1px_1fr] gap-x-11"
      >
        <div>
          <h3 class="text-[20px] leading-6 font-semibold text-gray-800 mb-0">
            {{ $t('INTEGRATION_SETTINGS.MOBILE_APP.LOGIN_TITLE') }}
          </h3>
          <div class="text-base leading-6 text-gray-600 mt-2">
            {{ $t('INTEGRATION_SETTINGS.MOBILE_APP.QR_CAPTION') }}
          </div>
          <qr-code-generator />
        </div>

        <div class="bg-gray-100" />

        <div class="flex flex-col">
          <h3 class="text-[20px] leading-6 font-semibold text-gray-800 mb-0">
            {{ $t('INTEGRATION_SETTINGS.MOBILE_APP.FEATURES_TITLE') }}
          </h3>
          <div class="mt-8 flex flex-col gap-6">
            <div
              v-for="(feature, index) in features"
              :key="index"
              class="flex flex-row items-center gap-4"
            >
              <span
                class="w-10 h-10 shrink-0 bg-green-50 rounded-[8px] flex items-center justify-center"
              >
                <img :src="featureIcons[index]" alt="" />
              </span>
              <span class="text-base leading-6 text-[#000]">
                {{ feature }}
              </span>
            </div>
          </div>

          <div
            class="mt-auto min-h-[100px] bg-green-50 rounded-[8px] p-5 relative"
          >
            <div class="text-lg leading-6 font-semibold text-gray-800">
              {{ $t('INTEGRATION_SETTINGS.MOBILE_APP.NEED_HELP') }}
            </div>
            <img
              :src="phoneImage"
              class="absolute -top-[79px] ltr:-right-[18px] rtl:-left-[18px] rtl:-scale-x-100 w-[124px] h-[180px]"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import phoneImage from 'dashboard/assets/images/mobile-app-phone.png';
import quickPhrasesIcon from 'dashboard/assets/images/mobile-quick-phrases.svg';
import userCardIcon from 'dashboard/assets/images/mobile-user-card-02.svg';
import userGroupIcon from 'dashboard/assets/images/mobile-user-group-01.svg';
import bellIcon from 'dashboard/assets/images/mobile-bell.svg';
import chartLineIcon from 'dashboard/assets/images/mobile-chart-line-01.svg';
import IntegrationPageHeader from '../components/IntegrationPageHeader.vue';
import QrCodeGenerator from './QrCodeGenerator.vue';

const FEATURE_ICONS = [
  quickPhrasesIcon,
  userCardIcon,
  userGroupIcon,
  bellIcon,
  chartLineIcon,
];

export default {
  name: 'MobileApp',
  components: { IntegrationPageHeader, QrCodeGenerator },
  data() {
    return {
      phoneImage,
      featureIcons: FEATURE_ICONS,
    };
  },
  computed: {
    features() {
      return this.$t('INTEGRATION_SETTINGS.MOBILE_APP.FEATURES');
    },
  },
};
</script>
